import { ValidationStatus } from './mfe-common.interfaces';

export interface PhoneGetData {
  phoneNumber: string;
  isMobile: boolean;
  validationStatus: ValidationStatus;
}
